module.exports = __webpack_public_path__ + "static/media/OpenSansCondensed-Light.3589bddb.ttf";